
import React, { useState } from 'react';
import './SalesDashboard.css';

const Enquiry = () => {
  // Initial enquiries data - integrated from Sourcing converted leads
  const [enquiries, setEnquiries] = useState([
    {
      id: 1,
      enquiryNo: 'ENQ-X1Y2Z',
      client: 'Acme Industries',
      requirements: 'Looking for industrial automation solutions - 500 units of SKU-204, custom branding',
      estimatedBudget: '₹8,50,000',
      quote: '₹9,50,000',
      timeline: '6 weeks',
      status: 'Quote Submitted',
      enquiryDate: '2024-12-01',
      assignedTo: 'Priya (Exec)',
      sourceLeadId: 1,
      sourceLeadName: 'Rohit Sharma',
      quotePrepared: true,
      quoteSubmitted: true,
      adminStatus: 'approved', // 'approved', 'rejected', 'revise'
      adminRemarks: 'Quote approved by admin. Proceed with client.',
      quoteDetails: {
        proposedQuote: '₹9,50,000',
        validUntil: '2025-01-15',
        message: 'Quote accepted by client',
        preparedDate: '2024-12-02',
        submittedDate: '2024-12-03',
        version: 2
      },
      quoteVersions: [
        {
          version: 1,
          proposedQuote: '₹8,50,000',
          validUntil: '2024-12-30',
          message: 'Initial quote',
          preparedDate: '2024-12-01',
          submittedDate: '2024-12-01',
          status: 'Quote Submitted'
        },
        {
          version: 2,
          proposedQuote: '₹9,50,000',
          validUntil: '2025-01-15',
          message: 'Revised quote',
          preparedDate: '2024-12-02',
          submittedDate: '2024-12-03',
          status: 'Quote Submitted'
        }
      ]
    },
    {
      id: 2,
      enquiryNo: 'ENQ-M3N4O',
      client: 'Acme Industries',
      requirements: 'Service contract renewal for existing automation setup',
      estimatedBudget: '₹2,50,000',
      quote: '₹2,75,000',
      timeline: '2 weeks',
      status: 'Quote Submitted',
      enquiryDate: '2024-12-05',
      assignedTo: 'Karan (Exec)',
      sourceLeadId: 1,
      sourceLeadName: 'Rohit Sharma',
      quotePrepared: true,
      quoteSubmitted: true,
      adminStatus: 'rejected',
      adminRemarks: 'Budget too high. Request revision.',
      quoteDetails: {
        proposedQuote: '₹2,75,000',
        validUntil: '2024-12-30',
        message: 'Awaiting client response',
        preparedDate: '2024-12-05',
        submittedDate: '2024-12-05',
        version: 1
      },
      quoteVersions: [{
        version: 1,
        proposedQuote: '₹2,75,000',
        validUntil: '2024-12-30',
        message: 'Awaiting client response',
        preparedDate: '2024-12-05',
        submittedDate: '2024-12-05',
        status: 'Quote Submitted'
      }]
    },
    {
      id: 3,
      enquiryNo: 'ENQ-P9Q3R',
      client: 'Nimbus Tech',
      requirements: 'Cloud infrastructure setup and migration services',
      estimatedBudget: '₹15,00,000',
      quote: '₹16,50,000',
      timeline: '8 weeks',
      status: 'Quote Submitted',
      enquiryDate: '2024-12-10',
      assignedTo: 'Priya (Exec)',
      sourceLeadId: 2,
      sourceLeadName: 'Anita Desai',
      quotePrepared: true,
      quoteSubmitted: true,
      adminStatus: 'pending', // pending admin review
      adminRemarks: '',
      quoteDetails: {
        proposedQuote: '₹16,50,000',
        validUntil: '2025-02-10',
        message: 'Contract signed - awaiting processing',
        preparedDate: '2024-12-10',
        submittedDate: '2024-12-10',
        version: 1
      },
      quoteVersions: [{
        version: 1,
        proposedQuote: '₹16,50,000',
        validUntil: '2025-02-10',
        message: 'Contract signed - awaiting processing',
        preparedDate: '2024-12-10',
        submittedDate: '2024-12-10',
        status: 'Quote Submitted'
      }]
    },
    {
      id: 4,
      enquiryNo: 'ENQ-R7S8T',
      client: 'Orbit Logistics',
      requirements: 'Fleet management software with real-time tracking',
      estimatedBudget: '₹12,00,000',
      quote: 'Pending',
      timeline: '10 weeks',
      status: 'Quote Prepared',
      enquiryDate: '2024-12-15',
      assignedTo: 'Karan (Exec)',
      sourceLeadId: 3,
      sourceLeadName: 'Vikram Mehta',
      quotePrepared: true,
      quoteSubmitted: false,
      adminStatus: 'pending',
      adminRemarks: '',
      quoteDetails: {
        proposedQuote: '₹13,20,000',
        validUntil: '2025-01-20',
        message: 'Quote ready for client review',
        preparedDate: '2024-12-18',
        version: 1
      },
      quoteVersions: [{
        version: 1,
        proposedQuote: '₹13,20,000',
        validUntil: '2025-01-20',
        message: 'Quote ready for client review',
        preparedDate: '2024-12-18',
        status: 'Quote Prepared'
      }]
    },
    {
      id: 5,
      enquiryNo: 'ENQ-U5V6W',
      client: 'BluePeak Foods',
      requirements: 'Cold storage monitoring and supply chain optimization',
      estimatedBudget: '₹6,00,000',
      quote: 'Pending',
      timeline: '4 weeks',
      status: 'Pending Quote',
      enquiryDate: '2024-12-20',
      assignedTo: 'Aarav (Admin)',
      sourceLeadId: 4,
      sourceLeadName: 'Sara Khan',
      quotePrepared: false,
      quoteSubmitted: false,
      adminStatus: 'pending',
      adminRemarks: '',
      quoteDetails: null,
      quoteVersions: []
    }
  ]);

  // Modal states
  const [isNewEnquiryModalOpen, setIsNewEnquiryModalOpen] = useState(false);
  const [isPrepareQuoteModalOpen, setIsPrepareQuoteModalOpen] = useState(false);
  const [isQuoteDetailsModalOpen, setIsQuoteDetailsModalOpen] = useState(false);
  const [isSendAgainModalOpen, setIsSendAgainModalOpen] = useState(false);
 
  const [isSendToClientModalOpen, setIsSendToClientModalOpen] = useState(false);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);
  const [viewQuoteDetails, setViewQuoteDetails] = useState(null);
  const [activeVersion, setActiveVersion] = useState(null);
  
  // Admin action form state
  

  // Send to client form state
  const [sendToClientForm, setSendToClientForm] = useState({
    clientName: '',
    clientEmail: '',
    clientPhone: '',
    additionalMessage: ''
  });

  // Quote form state for preparing quote
  const [quoteForm, setQuoteForm] = useState({
    proposedQuote: '',
    validUntil: '',
    message: '',
    document: null
  });

  // Document preview URL
  const [documentPreviewUrl, setDocumentPreviewUrl] = useState(null);

  // Form state for new enquiry
  const [formData, setFormData] = useState({
    clientCompany: '',
    estimatedBudget: '',
    timeline: '',
    requirements: '',
    enquiryDate: new Date().toISOString().split('T')[0],
    assignedTo: 'Aarav (Admin)'
  });

  // Options for assigned to
  const assigneeOptions = ['Aarav (Admin)', 'Priya (Exec)', 'Karan (Exec)', 'Neha (Manager)', 'Raj (Sales)'];

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle quote form change
  const handleQuoteChange = (e) => {
    const { name, value } = e.target;
    setQuoteForm(prev => ({ ...prev, [name]: value }));
  };

  // Handle admin action form change
  

  // Handle send to client form change
  const handleSendToClientChange = (e) => {
    const { name, value } = e.target;
    setSendToClientForm(prev => ({ ...prev, [name]: value }));
  };

  // Handle document upload
  const handleDocumentUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert('File size should be less than 5MB');
        return;
      }
      
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowedTypes.includes(file.type)) {
        alert('Please upload PDF, JPEG, PNG, or DOC/DOCX files only');
        return;
      }
      
      setQuoteForm(prev => ({ ...prev, document: file }));
      
      if (file.type.startsWith('image/')) {
        const url = URL.createObjectURL(file);
        setDocumentPreviewUrl(url);
      } else {
        setDocumentPreviewUrl(null);
      }
    }
  };

  // Remove document
  const handleRemoveDocument = () => {
    setQuoteForm(prev => ({ ...prev, document: null }));
    if (documentPreviewUrl) {
      URL.revokeObjectURL(documentPreviewUrl);
      setDocumentPreviewUrl(null);
    }
  };

  // Add new enquiry manually
  const handleAddEnquiry = () => {
    if (!formData.clientCompany || !formData.estimatedBudget || !formData.timeline || !formData.requirements) {
      alert('Please fill all required fields: Client/Company, Estimated Budget, Timeline, and Requirements');
      return;
    }

    const newId = enquiries.length + 1;
    const newEnquiryNo = `ENQ-${Math.random().toString(36).substring(2, 7).toUpperCase()}`;

    const newEnquiry = {
      id: newId,
      enquiryNo: newEnquiryNo,
      client: formData.clientCompany,
      requirements: formData.requirements,
      estimatedBudget: formData.estimatedBudget,
      quote: 'Pending',
      timeline: formData.timeline,
      status: 'Pending Quote',
      enquiryDate: formData.enquiryDate,
      assignedTo: formData.assignedTo,
      sourceLeadId: null,
      sourceLeadName: null,
      quotePrepared: false,
      quoteSubmitted: false,
      adminStatus: 'pending',
      adminRemarks: '',
      quoteDetails: null,
      quoteVersions: []
    };

    setEnquiries([...enquiries, newEnquiry]);

    setFormData({
      clientCompany: '',
      estimatedBudget: '',
      timeline: '',
      requirements: '',
      enquiryDate: new Date().toISOString().split('T')[0],
      assignedTo: 'Aarav (Admin)'
    });

    setIsNewEnquiryModalOpen(false);
    alert('Enquiry added successfully!');
  };

  

  // Open send to client modal
  const openSendToClientModal = (enquiry) => {
    setSelectedEnquiry(enquiry);
    setSendToClientForm({
      clientName: enquiry.client,
      clientEmail: '',
      clientPhone: '',
      additionalMessage: `Dear ${enquiry.client},\n\nPlease find attached the final quote for your enquiry.\n\nEnquiry #: ${enquiry.enquiryNo}\nQuote Amount: ${enquiry.quote}\n\nBest regards,\nSales Team`
    });
    setIsSendToClientModalOpen(true);
  };

  // Handle send to client submit
  const handleSendToClientSubmit = () => {
    if (!sendToClientForm.clientEmail) {
      alert('Please enter client email address');
      return;
    }

    // In a real application, this would send an email/notification to the client
    alert(`✓ Quote sent successfully to ${selectedEnquiry.client} at ${sendToClientForm.clientEmail}!\n\nA copy has been sent to your email as well.`);
    
    // Update enquiry to mark that it has been sent to client
    const updatedEnquiries = enquiries.map(enq =>
      enq.id === selectedEnquiry.id
        ? {
            ...enq,
            sentToClient: true,
            sentToClientDate: new Date().toLocaleDateString(),
            clientEmail: sendToClientForm.clientEmail
          }
        : enq
    );
    
    setEnquiries(updatedEnquiries);
    setIsSendToClientModalOpen(false);
    setSelectedEnquiry(null);
    setSendToClientForm({
      clientName: '',
      clientEmail: '',
      clientPhone: '',
      additionalMessage: ''
    });
  };

  // Open prepare quote modal
  const openPrepareQuoteModal = (enquiry) => {
    setSelectedEnquiry(enquiry);
    setQuoteForm({
      proposedQuote: enquiry.quote !== 'Pending' && enquiry.quoteDetails ? enquiry.quoteDetails.proposedQuote.replace('₹', '') : '',
      validUntil: enquiry.quoteDetails?.validUntil || '',
      message: enquiry.quoteDetails?.message || `Dear ${enquiry.client},\n\nRegarding your enquiry for:\n${enquiry.requirements}\n\nEstimated Budget: ${enquiry.estimatedBudget}\nTimeline: ${enquiry.timeline}\nEnquiry Date: ${enquiry.enquiryDate}\n\nPlease find our quote below.\n\nBest regards,\nSales Team`,
      document: null
    });
    setDocumentPreviewUrl(null);
    setIsPrepareQuoteModalOpen(true);
  };

  // Open send again modal
  const openSendAgainModal = (enquiry) => {
    setSelectedEnquiry(enquiry);
    const nextVersion = (enquiry.quoteVersions.length || 0) + 1;
    setActiveVersion(nextVersion);
    setQuoteForm({
      proposedQuote: enquiry.quoteDetails?.proposedQuote?.replace('₹', '') || '',
      validUntil: '',
      message: `Version ${nextVersion}: Revised quote for ${enquiry.client}\n\nPrevious Quote: ${enquiry.quote}\n\nPlease find the revised quote attached.\n\nBest regards,\nSales Team`,
      document: null
    });
    setDocumentPreviewUrl(null);
    setIsSendAgainModalOpen(true);
  };

  // Save quote as new version
  const handleSendAgainQuote = () => {
    if (!quoteForm.proposedQuote) {
      alert('Please enter a proposed quote amount');
      return;
    }

    const nextVersion = (selectedEnquiry.quoteVersions.length || 0) + 1;
    const newVersionDetails = {
      version: nextVersion,
      proposedQuote: `₹${quoteForm.proposedQuote}`,
      validUntil: quoteForm.validUntil,
      message: quoteForm.message,
      preparedDate: new Date().toLocaleDateString(),
      submittedDate: new Date().toLocaleDateString(),
      status: 'Quote Submitted',
      document: quoteForm.document ? {
        name: quoteForm.document.name,
        type: quoteForm.document.type,
        size: quoteForm.document.size,
        file: quoteForm.document
      } : null
    };

    const updatedEnquiries = enquiries.map(enq =>
      enq.id === selectedEnquiry.id
        ? {
            ...enq,
            quote: `₹${quoteForm.proposedQuote}`,
            status: 'Quote Submitted',
            quotePrepared: true,
            quoteSubmitted: true,
            adminStatus: 'pending', // Reset admin status for new version
            adminRemarks: '',
            quoteDetails: {
              proposedQuote: `₹${quoteForm.proposedQuote}`,
              validUntil: quoteForm.validUntil,
              message: quoteForm.message,
              preparedDate: new Date().toLocaleDateString(),
              submittedDate: new Date().toLocaleDateString(),
              version: nextVersion,
              document: quoteForm.document ? {
                name: quoteForm.document.name,
                type: quoteForm.document.type,
                size: quoteForm.document.size,
                file: quoteForm.document
              } : null
            },
            quoteVersions: [...(enq.quoteVersions || []), newVersionDetails]
          }
        : enq
    );

    setEnquiries(updatedEnquiries);
    alert(`✓ Quote Version ${nextVersion} sent successfully to ${selectedEnquiry.client}!`);
    setIsSendAgainModalOpen(false);
    setSelectedEnquiry(null);
    setActiveVersion(null);
    setQuoteForm({
      proposedQuote: '',
      validUntil: '',
      message: '',
      document: null
    });
    if (documentPreviewUrl) {
      URL.revokeObjectURL(documentPreviewUrl);
      setDocumentPreviewUrl(null);
    }
  };

  // Prepare/Save quote
  const handlePrepareQuote = () => {
    if (!quoteForm.proposedQuote) {
      alert('Please enter a proposed quote amount');
      return;
    }

    const version = 1;
    const newQuoteDetails = {
      proposedQuote: `₹${quoteForm.proposedQuote}`,
      validUntil: quoteForm.validUntil,
      message: quoteForm.message,
      preparedDate: new Date().toLocaleDateString(),
      version: version,
      document: quoteForm.document ? {
        name: quoteForm.document.name,
        type: quoteForm.document.type,
        size: quoteForm.document.size,
        file: quoteForm.document
      } : null
    };

    const updatedEnquiries = enquiries.map(enq =>
      enq.id === selectedEnquiry.id
        ? {
            ...enq,
            quote: `₹${quoteForm.proposedQuote}`,
            status: 'Quote Prepared',
            quotePrepared: true,
            quoteSubmitted: false,
            quoteDetails: newQuoteDetails,
            quoteVersions: [{
              ...newQuoteDetails,
              status: 'Quote Prepared'
            }]
          }
        : enq
    );

    setEnquiries(updatedEnquiries);
    alert(`✓ Quote prepared successfully for ${selectedEnquiry.client}!`);
    setIsPrepareQuoteModalOpen(false);
    setSelectedEnquiry(null);
    setQuoteForm({
      proposedQuote: '',
      validUntil: '',
      message: '',
      document: null
    });
    if (documentPreviewUrl) {
      URL.revokeObjectURL(documentPreviewUrl);
      setDocumentPreviewUrl(null);
    }
  };

  // Submit quote
  const handleSubmitQuote = (enquiry) => {
    const updatedQuoteDetails = {
      ...enquiry.quoteDetails,
      submittedDate: new Date().toLocaleDateString(),
      status: 'Quote Submitted'
    };
    
    const updatedVersions = (enquiry.quoteVersions || []).map(ver =>
      ver.version === enquiry.quoteDetails.version
        ? { ...ver, submittedDate: new Date().toLocaleDateString(), status: 'Quote Submitted' }
        : ver
    );

    const updatedEnquiries = enquiries.map(enq =>
      enq.id === enquiry.id
        ? {
            ...enq,
            status: 'Quote Submitted',
            quoteSubmitted: true,
            quoteDetails: updatedQuoteDetails,
            quoteVersions: updatedVersions
          }
        : enq
    );

    setEnquiries(updatedEnquiries);
    alert(`✓ Quote submitted successfully to ${enquiry.client}!`);
  };

  // View quote details
  const viewQuoteDetailsModal = (enquiry) => {
    setViewQuoteDetails(enquiry);
    setIsQuoteDetailsModalOpen(true);
  };

  // Download document
  const downloadDocument = (doc) => {
    if (doc && doc.file) {
      const url = URL.createObjectURL(doc.file);
      const a = document.createElement('a');
      a.href = url;
      a.download = doc.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } else {
      alert('Document file not available for download');
    }
  };

  // Get status badge class
  const getStatusClass = (status) => {
    switch(status) {
      case 'Quote Submitted': return 'status-submitted';
      case 'Quote Prepared': return 'status-prepared';
      case 'Pending Quote': return 'status-pending';
      case 'Quote Rejected': return 'status-rejected';
      case 'Revision Requested': return 'status-revise';
      default: return 'status-pending';
    }
  };

  // Get admin status badge class
  const getAdminStatusClass = (adminStatus) => {
    switch(adminStatus) {
      case 'approved': return 'admin-status-approved';
      case 'rejected': return 'admin-status-rejected';
      case 'revise': return 'admin-status-revise';
      default: return 'admin-status-pending';
    }
  };

  // Get admin status display text
  const getAdminStatusText = (adminStatus) => {
    switch(adminStatus) {
      case 'approved': return 'Approved';
      case 'rejected': return 'Rejected';
      case 'revise': return 'Revise Requested';
      default: return 'Pending Review';
    }
  };

  // Count statistics
  const totalEnquiries = enquiries.length;
  const quoteSubmittedCount = enquiries.filter(e => e.status === 'Quote Submitted').length;
  const quotePreparedCount = enquiries.filter(e => e.status === 'Quote Prepared').length;
  const pendingCount = enquiries.filter(e => e.status === 'Pending Quote').length;
  const approvedCount = enquiries.filter(e => e.adminStatus === 'approved').length;
  const pendingReviewCount = enquiries.filter(e => e.adminStatus === 'pending' && e.status !== 'Pending Quote').length;

  return (
    <div className="enq-container">
      <div className="enq-wrapper">
        {/* Header Section */}
        <div className="enq-header">
          <div className="enq-header-top">
            <div className="enq-header-left">
              <h1 className="enq-title">Enquiry</h1>
              
            </div>
            <button className="enq-new-btn" onClick={() => setIsNewEnquiryModalOpen(true)}>
              + New enquiry
            </button>
          </div>
          <p className="enq-description">Active enquiries from sourced leads. Prepare quote → Ready to send → Submitted → Admin Review → Send to Client.</p>
        </div>

        {/* Statistics Cards */}
        <div className="enq-stats">
          <div className="enq-stat-card">
            <div className="enq-stat-label">TOTAL ENQUIRIES</div>
            <div className="enq-stat-value">{totalEnquiries}</div>
          </div>
          <div className="enq-stat-card">
            <div className="enq-stat-label">QUOTE SUBMITTED</div>
            <div className="enq-stat-value">{quoteSubmittedCount}</div>
          </div>
          <div className="enq-stat-card">
            <div className="enq-stat-label">QUOTE PREPARED</div>
            <div className="enq-stat-value">{quotePreparedCount}</div>
          </div>
          <div className="enq-stat-card">
            <div className="enq-stat-label">PENDING QUOTE</div>
            <div className="enq-stat-value">{pendingCount}</div>
          </div>
          <div className="enq-stat-card">
            <div className="enq-stat-label">APPROVED</div>
            <div className="enq-stat-value">{approvedCount}</div>
          </div>
          <div className="enq-stat-card">
            <div className="enq-stat-label">PENDING REVIEW</div>
            <div className="enq-stat-value">{pendingReviewCount}</div>
          </div>
        </div>

        {/* Enquiries Table */}
        <div className="enq-table-section">
          <div className="enq-table-wrapper">
            <div className="enq-table-container">
              <table className="enq-table">
                <thead>
                  <tr>
                    <th>SR. NO.</th>
                    <th>ENQUIRY #</th>
                    <th>CLIENT</th>
                    <th>REQUIREMENTS</th>
                    <th>ENQ. DATE</th>
                    <th>EST. BUDGET</th>
                    <th>TIMELINE</th>
                    <th>ASSIGNED TO</th>
                    <th>STATUS</th>
                    <th>VERSION</th>
                    <th>ADMIN STATUS</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {enquiries.map((enquiry, index) => (
                    <tr key={enquiry.id}>
                      <td data-label="SR. NO.">{index + 1}</td>
                      <td data-label="ENQUIRY #" className="enq-cell-enquiry-no">{enquiry.enquiryNo}</td>
                      <td data-label="CLIENT">{enquiry.client}</td>
                      <td data-label="REQUIREMENTS" className="enq-cell-requirements">{enquiry.requirements}</td>
                      <td data-label="ENQ. DATE">{enquiry.enquiryDate}</td>
                      <td data-label="EST. BUDGET">{enquiry.estimatedBudget}</td>
                      <td data-label="TIMELINE">{enquiry.timeline}</td>
                      <td data-label="ASSIGNED TO">{enquiry.assignedTo}</td>
                      <td data-label="STATUS">
                        <span className={`enq-status-badge ${getStatusClass(enquiry.status)}`}>
                          {enquiry.status}
                        </span>
                      </td>
                      <td data-label="VERSION">
                        {enquiry.quoteVersions && enquiry.quoteVersions.length > 0 ? (
                          <span className="enq-version-badge">v{enquiry.quoteVersions.length}</span>
                        ) : (
                          <span className="enq-version-badge enq-version-none">-</span>
                        )}
                      </td>
                      <td data-label="ADMIN STATUS">
                        <div className="enq-admin-status-cell">
                          <span className={`enq-admin-status-badge ${getAdminStatusClass(enquiry.adminStatus)}`}>
                            {getAdminStatusText(enquiry.adminStatus)}
                          </span>
                          {enquiry.adminRemarks && enquiry.adminStatus !== 'pending' && (
                            <span className="enq-admin-remarks-tooltip" title={enquiry.adminRemarks}>
                              
                            </span>
                          )}
                        </div>
                      </td>
                      <td data-label="ACTION">
                        {/* Prepare Quote - for Pending Quote status */}
                        {enquiry.status === 'Pending Quote' && !enquiry.quotePrepared && (
                          <button className="enq-prepare-quote-btn" onClick={() => openPrepareQuoteModal(enquiry)}>
                            Prepare Quote
                          </button>
                        )}
                        
                        {/* Quote Prepared actions */}
                        {enquiry.status === 'Quote Prepared' && enquiry.quotePrepared && !enquiry.quoteSubmitted && (
                          <div className="enq-action-group">
                            <button className="enq-view-quote-btn" onClick={() => viewQuoteDetailsModal(enquiry)}>
                              View
                            </button>
                            <button className="enq-submit-quote-btn" onClick={() => handleSubmitQuote(enquiry)}>
                              Submit
                            </button>
                            <button className="enq-edit-quote-btn" onClick={() => openPrepareQuoteModal(enquiry)}>
                              Edit
                            </button>
                          </div>
                        )}
                        
                        {/* Quote Submitted actions - Show admin action button */}
                        {enquiry.status === 'Quote Submitted' && enquiry.quoteSubmitted && (
                          <div className="enq-action-group">
                            <button className="enq-view-quote-btn" onClick={() => viewQuoteDetailsModal(enquiry)}>
                              View
                            </button>
                            <button className="enq-send-again-btn" onClick={() => openSendAgainModal(enquiry)}>
                              Send Again
                            </button>
                            
                            {enquiry.adminStatus === 'approved' && !enquiry.sentToClient && (
                              <button className="enq-send-to-client-btn" onClick={() => openSendToClientModal(enquiry)}>
                                Send to Client
                              </button>
                            )}
                          </div>
                        )}
                        
                        {/* For rejected or revise status - show send again option */}
                        {(enquiry.status === 'Quote Rejected' || enquiry.status === 'Revision Requested') && (
                          <div className="enq-action-group">
                            <button className="enq-view-quote-btn" onClick={() => viewQuoteDetailsModal(enquiry)}>
                              View
                            </button>
                            <button className="enq-send-again-btn" onClick={() => openSendAgainModal(enquiry)}>
                              Send Revised Quote
                            </button>
                          </div>
                        )}
                        
                        {/* For already sent to client - show sent badge */}
                        {enquiry.sentToClient && (
                          <span className="enq-sent-badge">✓ Sent to Client</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* New Enquiry Modal */}
      {isNewEnquiryModalOpen && (
        <div className="enq-modal-overlay" onClick={() => setIsNewEnquiryModalOpen(false)}>
          <div className="enq-modal" onClick={(e) => e.stopPropagation()}>
            <div className="enq-modal-header">
              <h3>Add New Enquiry</h3>
              <button className="enq-modal-close" onClick={() => setIsNewEnquiryModalOpen(false)}>×</button>
            </div>
            <div className="enq-modal-body">
              <div className="enq-form-row">
                <div className="enq-form-group">
                  <label>Client / Company <span className="enq-required">*</span></label>
                  <input type="text" name="clientCompany" value={formData.clientCompany} onChange={handleInputChange} placeholder="Enter client or company name" />
                </div>
                <div className="enq-form-group">
                  <label>Enquiry Date <span className="enq-required">*</span></label>
                  <input type="date" name="enquiryDate" value={formData.enquiryDate} onChange={handleInputChange} />
                </div>
              </div>
              <div className="enq-form-row">
                <div className="enq-form-group">
                  <label>Estimated Budget (₹) <span className="enq-required">*</span></label>
                  <input type="text" name="estimatedBudget" value={formData.estimatedBudget} onChange={handleInputChange} placeholder="e.g., ₹5,00,000" />
                </div>
                <div className="enq-form-group">
                  <label>Timeline <span className="enq-required">*</span></label>
                  <input type="text" name="timeline" value={formData.timeline} onChange={handleInputChange} placeholder="e.g., 4 weeks" />
                </div>
              </div>
              <div className="enq-form-row">
                <div className="enq-form-group">
                  <label>Assigned To</label>
                  <select name="assignedTo" value={formData.assignedTo} onChange={handleInputChange}>
                    {assigneeOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                  </select>
                </div>
                <div className="enq-form-group">
                  <label>&nbsp;</label>
                  <div></div>
                </div>
              </div>
              <div className="enq-form-group">
                <label>Requirements <span className="enq-required">*</span></label>
                <textarea name="requirements" value={formData.requirements} onChange={handleInputChange} placeholder="Describe the requirements..." rows="3" />
              </div>
            </div>
            <div className="enq-modal-footer">
              <button className="enq-cancel-button" onClick={() => setIsNewEnquiryModalOpen(false)}>Cancel</button>
              <button className="enq-save-button" onClick={handleAddEnquiry}>Save enquiry</button>
            </div>
          </div>
        </div>
      )}

      {/* Send to Client Modal */}
      {isSendToClientModalOpen && selectedEnquiry && (
        <div className="enq-modal-overlay" onClick={() => setIsSendToClientModalOpen(false)}>
          <div className="enq-modal enq-client-modal" onClick={(e) => e.stopPropagation()}>
            <div className="enq-modal-header">
              <h3>Send Quote to Client - {selectedEnquiry.enquiryNo}</h3>
              <button className="enq-modal-close" onClick={() => setIsSendToClientModalOpen(false)}>×</button>
            </div>
            <div className="enq-modal-body">
              <div className="enq-enquiry-details">
                <div className="enq-detail-grid">
                  <div><strong>Client:</strong> {selectedEnquiry.client}</div>
                  <div><strong>Quote Amount:</strong> {selectedEnquiry.quote}</div>
                  <div><strong>Valid Until:</strong> {selectedEnquiry.quoteDetails?.validUntil || 'Not specified'}</div>
                </div>
              </div>

              <div className="enq-form-group">
                <label>Client Name <span className="enq-required">*</span></label>
                <input type="text" name="clientName" value={sendToClientForm.clientName} onChange={handleSendToClientChange} placeholder="Enter client name" />
              </div>

              <div className="enq-form-group">
                <label>Client Email <span className="enq-required">*</span></label>
                <input type="email" name="clientEmail" value={sendToClientForm.clientEmail} onChange={handleSendToClientChange} placeholder="client@example.com" />
              </div>

              <div className="enq-form-group">
                <label>Client Phone (Optional)</label>
                <input type="tel" name="clientPhone" value={sendToClientForm.clientPhone} onChange={handleSendToClientChange} placeholder="+91 XXXXX XXXXX" />
              </div>

              <div className="enq-form-group">
                <label>Additional Message</label>
                <textarea name="additionalMessage" value={sendToClientForm.additionalMessage} onChange={handleSendToClientChange} rows="5" placeholder="Write your message to the client..." />
              </div>

              <div className="enq-quote-summary">
                <h4>Quote Summary</h4>
                <div className="enq-summary-row">
                  <span>Enquiry #:</span>
                  <strong>{selectedEnquiry.enquiryNo}</strong>
                </div>
                <div className="enq-summary-row">
                  <span>Total Quote Amount:</span>
                  <strong className="enq-summary-amount">{selectedEnquiry.quote}</strong>
                </div>
                <div className="enq-summary-row">
                  <span>Valid Until:</span>
                  <strong>{selectedEnquiry.quoteDetails?.validUntil || 'Not specified'}</strong>
                </div>
              </div>
            </div>
            <div className="enq-modal-footer">
              <button className="enq-cancel-button" onClick={() => setIsSendToClientModalOpen(false)}>Cancel</button>
              <button className="enq-send-client-btn" onClick={handleSendToClientSubmit}>
                Send to Client
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Prepare Quote Modal */}
      {isPrepareQuoteModalOpen && selectedEnquiry && (
        <div className="enq-modal-overlay" onClick={() => setIsPrepareQuoteModalOpen(false)}>
          <div className="enq-modal enq-quote-modal" onClick={(e) => e.stopPropagation()}>
            <div className="enq-modal-header">
              <h3>{selectedEnquiry.quotePrepared ? 'Edit Quote' : 'Prepare Quote'} - {selectedEnquiry.enquiryNo}</h3>
              <button className="enq-modal-close" onClick={() => setIsPrepareQuoteModalOpen(false)}>×</button>
            </div>
            <div className="enq-modal-body">
              <div className="enq-enquiry-details">
                <div className="enq-detail-grid">
                  <div><strong>Client:</strong> {selectedEnquiry.client}</div>
                  <div><strong>Enquiry Date:</strong> {selectedEnquiry.enquiryDate}</div>
                  <div><strong>Requirements:</strong> {selectedEnquiry.requirements}</div>
                  <div><strong>Estimated Budget:</strong> {selectedEnquiry.estimatedBudget}</div>
                  <div><strong>Timeline:</strong> {selectedEnquiry.timeline}</div>
                  <div><strong>Assigned To:</strong> {selectedEnquiry.assignedTo}</div>
                </div>
              </div>

              <div className="enq-form-group">
                <label>Message to Client <span className="enq-required">*</span></label>
                <textarea name="message" value={quoteForm.message} onChange={handleQuoteChange} rows="5" placeholder="Write your message here..." />
              </div>

              <div className="enq-form-row">
                <div className="enq-form-group">
                  <label>Proposed Quote (₹) <span className="enq-required">*</span></label>
                  <input type="text" name="proposedQuote" value={quoteForm.proposedQuote} onChange={handleQuoteChange} placeholder="e.g., 920000" />
                </div>
                <div className="enq-form-group">
                  <label>Valid Until</label>
                  <input type="date" name="validUntil" value={quoteForm.validUntil} onChange={handleQuoteChange} />
                </div>
              </div>

              <div className="enq-form-group">
                <label>Supporting Document (PDF, Image, DOC)</label>
                <div className="enq-file-upload">
                  <input type="file" id="quoteDocument" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" onChange={handleDocumentUpload} style={{ display: 'none' }} />
                  <button type="button" className="enq-upload-btn" onClick={() => document.getElementById('quoteDocument').click()}>
                    📎 Choose File
                  </button>
                  {quoteForm.document && (
                    <div className="enq-file-info">
                      <span className="enq-file-name">{quoteForm.document.name}</span>
                      <button type="button" className="enq-remove-file" onClick={handleRemoveDocument}>×</button>
                      {documentPreviewUrl && (
                        <div className="enq-document-preview">
                          <img src={documentPreviewUrl} alt="Preview" className="enq-preview-img" />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="enq-modal-footer">
              <button className="enq-cancel-button" onClick={() => setIsPrepareQuoteModalOpen(false)}>Cancel</button>
              <button className="enq-save-quote-btn" onClick={handlePrepareQuote}>
                {selectedEnquiry.quotePrepared ? 'Update Quote' : 'Save & Ready to Send'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Send Again Modal */}
      {isSendAgainModalOpen && selectedEnquiry && (
        <div className="enq-modal-overlay" onClick={() => setIsSendAgainModalOpen(false)}>
          <div className="enq-modal enq-quote-modal" onClick={(e) => e.stopPropagation()}>
            <div className="enq-modal-header">
              <h3>Send New Quote Version - {selectedEnquiry.enquiryNo} (Version {activeVersion})</h3>
              <button className="enq-modal-close" onClick={() => setIsSendAgainModalOpen(false)}>×</button>
            </div>
            <div className="enq-modal-body">
              <div className="enq-enquiry-details">
                <div className="enq-detail-grid">
                  <div><strong>Client:</strong> {selectedEnquiry.client}</div>
                  <div><strong>Previous Quote:</strong> {selectedEnquiry.quote}</div>
                  <div><strong>Requirements:</strong> {selectedEnquiry.requirements}</div>
                  <div><strong>Estimated Budget:</strong> {selectedEnquiry.estimatedBudget}</div>
                  <div><strong>Timeline:</strong> {selectedEnquiry.timeline}</div>
                </div>
              </div>

              {selectedEnquiry.quoteVersions && selectedEnquiry.quoteVersions.length > 0 && (
                <div className="enq-versions-history">
                  <label>Previous Versions</label>
                  <div className="enq-versions-list">
                    {selectedEnquiry.quoteVersions.map(ver => (
                      <div key={ver.version} className="enq-version-item">
                        <span className="enq-version-tag">v{ver.version}</span>
                        <span className="enq-version-quote">{ver.proposedQuote}</span>
                        <span className="enq-version-date">{ver.preparedDate}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="enq-form-group">
                <label>Message to Client <span className="enq-required">*</span></label>
                <textarea name="message" value={quoteForm.message} onChange={handleQuoteChange} rows="5" placeholder="Write your message here..." />
              </div>

              <div className="enq-form-row">
                <div className="enq-form-group">
                  <label>Revised Quote (₹) <span className="enq-required">*</span></label>
                  <input type="text" name="proposedQuote" value={quoteForm.proposedQuote} onChange={handleQuoteChange} placeholder="e.g., 920000" />
                </div>
                <div className="enq-form-group">
                  <label>Valid Until</label>
                  <input type="date" name="validUntil" value={quoteForm.validUntil} onChange={handleQuoteChange} />
                </div>
              </div>

              <div className="enq-form-group">
                <label>Supporting Document (PDF, Image, DOC)</label>
                <div className="enq-file-upload">
                  <input type="file" id="sendAgainDocument" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" onChange={handleDocumentUpload} style={{ display: 'none' }} />
                  <button type="button" className="enq-upload-btn" onClick={() => document.getElementById('sendAgainDocument').click()}>
                    📎 Choose File
                  </button>
                  {quoteForm.document && (
                    <div className="enq-file-info">
                      <span className="enq-file-name">{quoteForm.document.name}</span>
                      <button type="button" className="enq-remove-file" onClick={handleRemoveDocument}>×</button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="enq-modal-footer">
              <button className="enq-cancel-button" onClick={() => setIsSendAgainModalOpen(false)}>Cancel</button>
              <button className="enq-save-quote-btn" onClick={handleSendAgainQuote}>
                Send Version {activeVersion}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* View Quote Details Modal */}
      {isQuoteDetailsModalOpen && viewQuoteDetails && (
        <div className="enq-modal-overlay" onClick={() => setIsQuoteDetailsModalOpen(false)}>
          <div className="enq-modal enq-view-quote-modal" onClick={(e) => e.stopPropagation()}>
            <div className="enq-modal-header">
              <h3>Quote Details - {viewQuoteDetails.enquiryNo}</h3>
              <button className="enq-modal-close" onClick={() => setIsQuoteDetailsModalOpen(false)}>×</button>
            </div>
            <div className="enq-modal-body">
              <div className="enq-quote-details">
                <div className="enq-quote-detail-row">
                  <span className="enq-quote-label">Client:</span>
                  <span className="enq-quote-value">{viewQuoteDetails.client}</span>
                </div>
                <div className="enq-quote-detail-row">
                  <span className="enq-quote-label">Enquiry Date:</span>
                  <span className="enq-quote-value">{viewQuoteDetails.enquiryDate}</span>
                </div>
                <div className="enq-quote-detail-row">
                  <span className="enq-quote-label">Requirements:</span>
                  <span className="enq-quote-value">{viewQuoteDetails.requirements}</span>
                </div>
                <div className="enq-quote-detail-row">
                  <span className="enq-quote-label">Estimated Budget:</span>
                  <span className="enq-quote-value">{viewQuoteDetails.estimatedBudget}</span>
                </div>
                <div className="enq-quote-detail-row">
                  <span className="enq-quote-label">Timeline:</span>
                  <span className="enq-quote-value">{viewQuoteDetails.timeline}</span>
                </div>
                <div className="enq-quote-detail-row">
                  <span className="enq-quote-label">Current Quote:</span>
                  <span className="enq-quote-value enq-highlight">{viewQuoteDetails.quote}</span>
                </div>
                <div className="enq-quote-detail-row">
                  <span className="enq-quote-label">Valid Until:</span>
                  <span className="enq-quote-value">{viewQuoteDetails.quoteDetails?.validUntil || 'Not specified'}</span>
                </div>
                <div className="enq-quote-detail-row">
                  <span className="enq-quote-label">Prepared Date:</span>
                  <span className="enq-quote-value">{viewQuoteDetails.quoteDetails?.preparedDate || 'N/A'}</span>
                </div>
                {viewQuoteDetails.quoteDetails?.submittedDate && (
                  <div className="enq-quote-detail-row">
                    <span className="enq-quote-label">Submitted Date:</span>
                    <span className="enq-quote-value">{viewQuoteDetails.quoteDetails.submittedDate}</span>
                  </div>
                )}
                <div className="enq-quote-detail-row">
                  <span className="enq-quote-label">Version:</span>
                  <span className="enq-quote-value">v{viewQuoteDetails.quoteDetails?.version || 1}</span>
                </div>
                <div className="enq-quote-detail-row">
                  <span className="enq-quote-label">Admin Status:</span>
                  <span className={`enq-admin-status-badge ${getAdminStatusClass(viewQuoteDetails.adminStatus)}`}>
                    {getAdminStatusText(viewQuoteDetails.adminStatus)}
                  </span>
                </div>
                {viewQuoteDetails.adminRemarks && (
                  <div className="enq-quote-detail-row">
                    <span className="enq-quote-label">Admin Remarks:</span>
                    <span className="enq-quote-value">{viewQuoteDetails.adminRemarks}</span>
                  </div>
                )}
                <div className="enq-quote-detail-row">
                  <span className="enq-quote-label">Status:</span>
                  <span className={`enq-status-badge ${getStatusClass(viewQuoteDetails.status)}`}>
                    {viewQuoteDetails.status}
                  </span>
                </div>
                <div className="enq-quote-detail-row enq-quote-message">
                  <span className="enq-quote-label">Message:</span>
                  <span className="enq-quote-value">{viewQuoteDetails.quoteDetails?.message || 'No message'}</span>
                </div>
              </div>

              {viewQuoteDetails.quoteVersions && viewQuoteDetails.quoteVersions.length > 0 && (
                <div className="enq-versions-history">
                  <h4>Quote Version History</h4>
                  <div className="enq-versions-table">
                    <table className="enq-mini-table">
                      <thead>
                        <tr>
                          <th>Version</th>
                          <th>Quote Amount</th>
                          <th>Prepared Date</th>
                          <th>Submitted Date</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {viewQuoteDetails.quoteVersions.map(ver => (
                          <tr key={ver.version} className={ver.version === (viewQuoteDetails.quoteDetails?.version || 1) ? 'enq-current-version' : ''}>
                            <td>v{ver.version}</td>
                            <td>{ver.proposedQuote}</td>
                            <td>{ver.preparedDate}</td>
                            <td>{ver.submittedDate || '-'}</td>
                            <td><span className={`enq-status-badge ${getStatusClass(ver.status)}`}>{ver.status}</span></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
            <div className="enq-modal-footer">
              <button className="enq-cancel-button" onClick={() => setIsQuoteDetailsModalOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Enquiry;